"use strict";

var _regeneratorRuntime = require("/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function readFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function (e) {
      return resolve(e.target.result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };

    reader.readAsDataURL(file);
  });
}

exports.readFile = readFile;

function getDataFromReadFile(_x) {
  return _getDataFromReadFile.apply(this, arguments);
}

function _getDataFromReadFile() {
  _getDataFromReadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(Array.from(files).map(function (file) {
              return readFile(file);
            }));

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDataFromReadFile.apply(this, arguments);
}

exports.getDataFromReadFile = getDataFromReadFile;